import { FaCheck } from "react-icons/fa";

import Title from "components/atoms/Title";

import ServiceFeeCalculator from "./ServiceFeeCalculator";

/* ********** */

const AccountingAuditing = ({ services }) => {
  // ******
  return (
    <div className="container">
      <div className="row justify-center">
        <div className="col-12 lg:col-10">
          <Title
            text="Accounting and Auditing"
            className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10"
          />
          <p className="mb-4">
            Our accounting and auditing service covers the following areas to
            keep you stay compliance with reporting obligations:
          </p>
          <ul>
            <li className="mb-4 flex items-center gap-3">
              <p>
                <FaCheck className="text-bbc-brand-500 " size={12} />
              </p>
              <p>
                Preparing annual statutory accounts i.e Profit &amp; Loss
                account, Balance Sheet, Trial Balance...
              </p>
            </li>
            <li className="mb-4 flex items-center gap-3">
              <p>
                <FaCheck className="text-bbc-brand-500 " size={12} />
              </p>
              <p>Audited financial statements</p>
            </li>
          </ul>
          <p className="mb-9 lg:mb-10">
            We charge fees for services depending on the quantity and complexity
            of your transactions.
          </p>
          <ServiceFeeCalculator services={services} />
        </div>
      </div>
    </div>
  );
};

export default AccountingAuditing;
